<template >
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-user</v-icon>
      {{ editStatus == true ? `Editing: ${event.title}` : "New Event Request:"}}
    </v-toolbar>
    <v-form
      ref="submissionForm"
      :lazy-validation="lazyValidation"
      v-model="formValidation"
    >
      <v-row align="center" no-gutters>
        <v-col cols="12" md="4" offset-md="8">
          <v-select
            v-if="editStatus == true"
            class="ma-2"
            outlined
            item-color="secondary"
            color="secondary"
            :items="getStatusOptions"
            v-model="event.status"
            label="Status:"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-container fluid>
        <v-toolbar dense dark tile flat class="title text-center text-md-left">
          Contact Information
        </v-toolbar>
        <v-row dense>
          <v-col cols="12">
            <v-card flat color="grey lighten-3" class="body-1">
              * Required Fields
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="event.name"
              label="Name*"
              outlined
              color="secondary"
              :rules="rules.required"
            >
            </v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="event.phone"
              label="Phone"
              outlined
              type="tel"
              color="secondary"
              v-mask="phoneMask"
              :rules="rules.phone"
            >
            </v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <v-text-field
              v-model="event.email"
              label="Email*"
              outlined
              color="secondary"
              :rules="rules.email"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-radio-group v-model="event.type" column label="Type of Request*">
              <v-radio label="Ministry Event of The Mount (on site)" value="ministry-onSite" color="accent"></v-radio>
              <v-radio label="Ministry Event of The Mount (off site)" value="ministry-offSite" color="accent"></v-radio>
              <v-radio label="Outside Group Requesting Use of The Mount Facilities" value="external" color="accent"></v-radio>
              <v-radio label="Overnight Stay Request" value="overnight" color="accent"></v-radio>
              <v-radio label="Personal Event" value="personal" color="accent"></v-radio>
              <v-radio label="Promotion Only" value="promotion" color="accent"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row dense v-if="event.type != ''">
          <v-col sm="12">
            <v-card flat color="grey lighten-3">
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                    {{getDisclaimer}}
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- CONDITIONAL COMPONENTS -->
      <commitMsg :commitDialog="commitDialog" @close="commitDialog = !commitDialog" @commit="commitUpdates"></commitMsg>
      <eventInfo      :eventInfo="event" v-if="event.type != ''"></eventInfo>
      <ministryEvent  :eventInfo="event" v-if="event.type == 'ministry-onSite' || event.type == 'ministry-offSite'"></ministryEvent>
      <resources      :eventInfo="event" v-if="event.type != '' && event.type != 'overnight' && event.type != 'promotion'"></resources>
      <otherItems     :eventInfo="event" v-if="event.type != '' && event.type != 'overnight' && event.type != 'promotion'"></otherItems>
      <overnight      :eventInfo="event" v-if="event.type == 'overnight'"></overnight>
      <promotion      :eventInfo="event" v-if="event.type == 'ministry-onSite' || event.type == 'ministry-offSite' || event.type == 'promotion'"></promotion>
      <v-row dense v-if="event.type != ''" class="text-center">
        <v-col cols="12" md="6">
          <v-btn class="mr-5" outlined color="red" @click="$emit('close')" v-if="editStatus == true">
            <v-icon left>fas fa-times</v-icon>
            Cancel
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="text-center">
          <v-btn outlined @click="getCommitMsg()" :disabled="!formValidation">
            <v-icon left> {{ editStatus == true ? 'fas fa-save' : 'far fa-paper-plane'}}</v-icon>
            {{ editStatus == true ? `Update Event` : "Submit Request"}}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
  import commitMsg      from '@/components/formComponents/commitMsg'
  import eventInfo      from '@/components/formComponents/eventInfo'
  import { mask }       from 'vue-the-mask'
  import mixins         from '@/plugins/mixins'
  import ministryEvent  from '@/components/formComponents/ministry'
  import otherItems     from '@/components/formComponents/otherItems'
  import overnight      from '@/components/formComponents/overnight'
  import promotion      from '@/components/formComponents/promotion'
  import resources      from '@/components/formComponents/resources'
  export default {
    mixins: [mixins],
    directives: {mask},
    props: {
      editStatus      : Boolean,
      submissionInfo  : Object
    },
    components: {
      commitMsg,
      eventInfo,
      ministryEvent,
      otherItems,
      overnight,
      promotion,
      resources
    },
    beforeMount(){
      if (this.editStatus == true){
        this.event = this.submissionInfo
      }
    },
    data(){
      return {
        commitDialog            : false,
        commitMsg               : "",
        event: {
          approvedKitchenPerson : "",
          approvedSoundPerson   : "",
          audience              : "",
          budgeted              : "",
          charge                : "",
          classrooms            : "",
          commitMessages        : [],
          costInfo              : "",
          custom                : "",
          description           : "",
          driver                : "",
          email                 : "",
          endDate               : "",
          endTime               : "",
          expectedNum           : "",
          extraInfo             : "",
          food                  : "",
          graphic               : "",
          groupName             : "",
          groupAddress          : "",
          location              : "",
          ministry              : "",
          name                  : "",
          objectives            : "",
          overnight   : {
            males : {
              adult             : null,
              twelveToSeventeen : null,
              zeroToEleven      : null,
            },
            females: {
              adult             : null,
              twelveToSeventeen : null,
              zeroToEleven      : null,
            },
            referralInfo: "",
            specialNeeds: ""
          },
          phone         : "",
          promotion     : [],
          recurring     : "",
          resources     : [],
          resourceNotes : "",
          reviews       : [],
          staffAssistance: "",
          status        : "",
          setupDate     : "",
          setupPerson   : "",
          startDate     : "",
          startTime     : "",
          teardown      : "",
          title         : "",
          type          : "",
          usingAV       : null,
          usingKitchen  : null
        },
        formValidation: false,
        lazyValidation: false
      }
    },
    methods: {
      commitUpdates(commitRecord){
        this.event.commitMessages.push(commitRecord)
        this.submitRequest()
      },
      getCommitMsg(){
        if (this.editStatus == true){
          this.commitDialog = true
        }
        else {
          this.submitRequest()
        }
      },
      submitRequest(){
        if (this.editStatus == true){
          this.$store.dispatch('updateRequest', this.event)
          this.$emit('close')
        }
        else {
          this.$store.dispatch('submitReq', this.event)
        }
      }
    },
    computed: {
      getDisclaimer(){
        let responses = {
          "external"          : "A word of caution: please do not consider this date confirmed until you have heard from The Mount office.",
          "ministry-onSite"   : "A word of caution: please do not consider this date confirmed until you have heard from The Mount office.",
          "ministry-offSite"  : "A word of caution: please do not consider this date confirmed until you have heard from The Mount office.",
          "overnight"         : "We love to host guests at The Mount.  We ask that you fill out this form so that we can see how we may best serve you during your stay.  Once this form has been received, it will be reviewed by one of our Mission Team Leaders.  One of them will contact you to confirm this date.  Please do not consider this date confirmed until you have spoken with one of the team.  If you have any questions, please don't hesitate to call the church office at 859.824.4093",
          "personal"          : "A word of caution: please do not consider this date confirmed until you have heard from The Mount office.",
          "promotion"         : "Note: This option should ONLY be used if there are no church resources being requested but promotional efforts ONLY."
        }
        return responses[this.event.type]
      },
      getStatusOptions(){
        return this.$store.getters.getStatusOptions
      }
    }
  }
</script>
